interface Config {
	baseDomain: string
	clientUrl: string
	forgotPasswordUrl: string
	resetPasswordUrl: string
	loginUrl: string
	storeTokenUrl: string
	clearTokenUrl: string
	refreshTokenUrl: string
	signUpUrl: string
	v2SignUpUrl: string
	v2PrefixUrl: string
	sendOtpUrl: string
	validateOtpUrl: string
	currentUserUrl: string
	userCreateEventPublishUrl: string
	turnstileSiteKey: string
}

const baseDomain = process.env.REACT_APP_IK_PROXY_DOMAIN
if (!baseDomain) {
	console.log(`REACT_APP_IK_PROXY_DOMAIN is missing`)
	throw Error("REACT_APP_IK_PROXY_DOMAIN is missing")
}

const config: Config = {
	baseDomain: baseDomain,
	clientUrl: baseDomain ? `${baseDomain}/user/v1/clients` : "",
	forgotPasswordUrl: baseDomain ? `${baseDomain}/user/v1/users/forgot-password` : "",
	resetPasswordUrl: baseDomain ? `${baseDomain}/user/v1/users/reset-password` : "",
	loginUrl: baseDomain ? `${baseDomain}/user/v1/users/login` : "",
	storeTokenUrl: baseDomain ? `${baseDomain}/user/v1/users/auth-tokens` : "",
	clearTokenUrl: baseDomain ? `${baseDomain}/user/v1/users/clear-auth-tokens` : "",
	refreshTokenUrl: baseDomain ? `${baseDomain}/user/v1/users/token/refresh` : "",
	signUpUrl: baseDomain ? `${baseDomain}/user/v1/users/onboard` : "",
	v2SignUpUrl: baseDomain ? `${baseDomain}/user/v2/auth/signup` : "",
	v2PrefixUrl: baseDomain ? `${baseDomain}/user/v2` : "",
	sendOtpUrl: baseDomain ? `${baseDomain}/user/v1/users/mfa/send` : "",
	validateOtpUrl: baseDomain ? `${baseDomain}/user/v1/users/mfa/validate` : "",
	currentUserUrl: baseDomain ? `${baseDomain}/user/v1/users/current` : "",
	userCreateEventPublishUrl: baseDomain ? `${baseDomain}/user/v1/user-events/publish` : "",
	// Empty when unset: the widget is simply not rendered, rather than rendering a broken one.
	turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || "",
}

export default config
